// Global state manager for video transitions
const videoTransitionState = {
    isTransitionInProgress: false,
    isSeamlessTransition: false,
    transitionStartTime: null,
    activeInstanceId: null,
    transitionLockTimeout: null,
    isDebugEnabled: false
};

// Timeout duration for transition lock (5 seconds)
const TRANSITION_LOCK_TIMEOUT = 5000;

const debug = (...args) => {
    if (videoTransitionState.isDebugEnabled) {
        //console.log('[VideoTransitionState]', ...args);
    }
};

export const useVideoTransitionState = () => {
    const acquireTransitionLock = (instanceId) => {
        if (videoTransitionState.isTransitionInProgress) {
            debug(`Transition already in progress, lock acquisition failed for instance ${instanceId}`);
            return false;
        }

        // Clear any existing timeout
        if (videoTransitionState.transitionLockTimeout) {
            clearTimeout(videoTransitionState.transitionLockTimeout);
        }

        // Set the transition state
        videoTransitionState.isTransitionInProgress = true;
        videoTransitionState.activeInstanceId = instanceId;
        videoTransitionState.transitionStartTime = Date.now();

        // Set a timeout to automatically release the lock
        videoTransitionState.transitionLockTimeout = setTimeout(() => {
            if (videoTransitionState.isTransitionInProgress) {
                debug(`Transition lock timed out after ${TRANSITION_LOCK_TIMEOUT}ms`);
                releaseTransitionLock(instanceId);
            }
        }, TRANSITION_LOCK_TIMEOUT);

        debug(`Transition lock acquired by instance ${instanceId}`);
        return true;
    };

    const releaseTransitionLock = (instanceId) => {
        // Only allow the active instance to release the lock
        if (videoTransitionState.activeInstanceId !== instanceId) {
            debug(`Instance ${instanceId} cannot release lock held by ${videoTransitionState.activeInstanceId}`);
            return false;
        }

        // Clear the timeout
        if (videoTransitionState.transitionLockTimeout) {
            clearTimeout(videoTransitionState.transitionLockTimeout);
            videoTransitionState.transitionLockTimeout = null;
        }

        // Reset the transition state
        videoTransitionState.isTransitionInProgress = false;
        videoTransitionState.isSeamlessTransition = false;
        videoTransitionState.transitionStartTime = null;
        videoTransitionState.activeInstanceId = null;

        debug(`Transition lock released by instance ${instanceId}`);
        return true;
    };

    const setSeamlessTransition = (instanceId, isSeamless) => {
        if (videoTransitionState.activeInstanceId !== instanceId) {
            debug(`Instance ${instanceId} cannot modify seamless state`);
            return false;
        }
        videoTransitionState.isSeamlessTransition = isSeamless;
        return true;
    };

    const getTransitionState = () => ({
        isTransitionInProgress: videoTransitionState.isTransitionInProgress,
        isSeamlessTransition: videoTransitionState.isSeamlessTransition,
        transitionStartTime: videoTransitionState.transitionStartTime,
        activeInstanceId: videoTransitionState.activeInstanceId
    });

    return {
        acquireTransitionLock,
        releaseTransitionLock,
        setSeamlessTransition,
        getTransitionState
    };
}; 